<div class="body" fxFlexFill fxLayout="column">
  <mat-toolbar color="primary" fxLayout="row">
    <button type="button"
            mat-fab color="primary"
            matTooltip="Add Scenario"
            (click)="addScenario()">+S
    </button>
    <div fxFlex="1 1 auto" fxLayoutAlign="center center" class="title">
      <div fxFlex="nogrow">
        <H1>The Mortgage Comparinator</H1>
        This is <b>NOT</b> financial advice!
      </div>
    </div>
    <button
      type="button"
      mat-fab color="accent"
      matTooltip="Report feature request" (click)="openFeatureRequest()"><mat-icon >question_answer</mat-icon></button>
    <button
      type="button"
      mat-fab color="accent"
      matTooltip="Donate" (click)="openBtc()"><mat-icon>attach_money</mat-icon></button>
    <button
      type="button"
      mat-fab color="accent"
      matTooltip="Show Help" (click)="openHelp()"><mat-icon>help</mat-icon>
    </button>
  </mat-toolbar>
  <mortgage-scenario
    *ngFor="let item of scenarioIds$| async "
    [scenarioId]="item">
  </mortgage-scenario>
  <router-outlet></router-outlet>
</div>
